import React from 'react';
import styled from 'styled-components';
import { Table, Message } from 'semantic-ui-react';

const StyledTable = styled(Table)`
 width: 700px !important;
  &&& {
    text-align: center;

    th, td {
      border: 1px solid #ccc;
      font-size: 13px !important;
    }

    th {
      background-color: #f7f7f7;
      font-size: 13px !important;
    }

    td {
      padding: 0.6rem;
      font-size: 13px !important;
    }
  }
`;

const Disclaimer = styled(Message)`
  &&& {
    margin-top: 2rem;
    background-color: #d9e2f3;
    color: #333;
    border: none;
  }
`;

const DieselConsumptionTable: React.FC = () => (
  <>
    <StyledTable celled compact={'very'}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Arbeitsgang</Table.HeaderCell>
          <Table.HeaderCell>Durchgänge</Table.HeaderCell>
          <Table.HeaderCell>durchschnittlicher Dieselverbrauch</Table.HeaderCell>
          <Table.HeaderCell>Einheit</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Nachsaat von Grünland</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>7,7</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Grässien mit Saatbettkombination und</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>12</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Übersaat von Gras, pneumatisch mit Striegel</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>4,2</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Grünland abschleppen inkl. Übersaat</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>3,2</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Grünland walzen</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>7</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Striegeln</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>2,9</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Mineraldünger streuen</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>1,7</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Gülle ausbringen, ab Lager, Schleppschuh, 15 m³, 12 m; 120 kW</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>9,6</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Gülle ausbringen, ab Lager, Schleppschlauch, 15 m³, 12 m; 120 kW</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>6,3</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Mähen mit Aufbereiter</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>3,3</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Mähen mit Rotationsmähwerk, Front‑Heck‑Kombination</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>3,7</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Wenden</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>2,8</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Schwaden</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>1,9–3,5</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Anwelkgut einlagern</Table.Cell>
          <Table.Cell>gesamte Ernte, 4 Schnitte</Table.Cell>
          <Table.Cell>4,7</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Grünmasse Ernte (Häckselkette)</Table.Cell>
          <Table.Cell>gesamte Ernte, 4 Schnitte</Table.Cell>
          <Table.Cell>24,5</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Anwelkgut Transport (Feld‑Silo), 1 km Entfernung</Table.Cell>
          <Table.Cell>gesamte Ernte, 4 Schnitte</Table.Cell>
          <Table.Cell>5,7</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Anwelkgut Transport (Feld‑Silo), 2 km Entfernung</Table.Cell>
          <Table.Cell>gesamte Ernte, 4 Schnitte</Table.Cell>
          <Table.Cell>9,3</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Anwelkgut Transport (Feld‑Silo), 5 km Entfernung</Table.Cell>
          <Table.Cell>gesamte Ernte, 4 Schnitte</Table.Cell>
          <Table.Cell>19,9</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Anwelkgut Transport (Feld‑Silo), 10 km Entfernung</Table.Cell>
          <Table.Cell>gesamte Ernte, 4 Schnitte</Table.Cell>
          <Table.Cell>37,6</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
      </Table.Body>
    </StyledTable>

    <Disclaimer>
      Dies sind lediglich Orientierungswerte! Genauere und mehr Werte finden Sie im Internet auf der Seite des KTBL-Dieselbedarf-Rechners:{' '}
      <a href='https://daten.ktbl.de/dieselbedarf/home.html' target='_blank' rel='noopener noreferrer'>
        https://daten.ktbl.de/dieselbedarf/home.html
      </a>
    </Disclaimer>
  </>
);

export default DieselConsumptionTable;